import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastNotificationService } from './toast-notification.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiRequestInterceptorService } from './api-request-interceptor.service';
import { ApiClient } from './api-client.service';
import { ImpersonationService } from './impersonation-service';
import { UIBlockingService } from './ui-blocking.service';
import { Router } from '@angular/router';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    ToastNotificationService,
      ApiClient,
      ImpersonationService,
      UIBlockingService,
      Router,
  ]
})
export class CoreModule { }
